import { Component, OnInit, ViewContainerRef,Renderer2 , ElementRef, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Modal } from 'angular2-modal/plugins/bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { EchexpaymentService } from '../echexpayment.service';
import { Helper } from '../helpers/helper';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';
import { Location } from '@angular/common';

@Component({
  selector: 'echexpayment-echexmerchant',
  templateUrl: './editechexmerchant.component.html',
  styleUrls: ['./echexmerchant.component.css'],
  providers: [Modal]
})
export class EditechexmerchantComponent implements OnInit {
	@ViewChild('submitButton') submitButton: ElementRef;
	@ViewChild('submit_Button') submit_Button: ElementRef;
	@ViewChild('submit_button') submit_button: ElementRef;
	echexMerchant: any = {};
	echexMerchantProfile: any = {};
	echexMerchantBankDetails: any = {};
	echexMerchantPlan: any = {};
	echexMerchantIp: any = {};
	echexMerchantDomain: any = {};
	public mask: Array<string | RegExp>;
	public token: string;
	public id: string;
  busy: Subscription;
	public filterQuery = "";
	public rowsOnPage = 10;
	public sortBy = "Id";
	public sortOrder = "asc";
	public addChecks: boolean=false;
	public addUsers: boolean=false;
	
	public val_plan_name: boolean=false;
	public val_plan_id: boolean=false;
	public val_no_of_cheque: boolean=false;
	public val_no_of_user: boolean=false;
	public val_amount: boolean=false;
	public val_status: boolean=false;
	public val_interval: boolean=false;
	public val_trial_period: boolean=false;
	public val_settings: boolean=false;
	public val_appear_in: boolean=false;

	public signature: boolean=false;
	public type_it: boolean=false;
	public validationAccountNumber: boolean = false;
	public validationRoutingNumber: boolean = false;
	public validationIndustrytype: boolean = false;
	public validationEmail: boolean = false;
	public invalidEmalAddress: boolean = false;
	public invalidEmail: boolean = false;
	public validationLastname: boolean = false;
	public validationFirstname: boolean = false;
	public validationWebsite: boolean = false;
	public validationBusinessname: boolean = false;
	public getDoc_List : any = [];
	public merchantId: string;
	public chequeerror_res:string;
	public doc_dataNotFound: boolean=false;
	NamecharacterLimitReached: { [key: string]: boolean } = {};

	public dataIpList: {};

	public VendorImage: string;
	public vendorimgValidate : boolean = false;
	public imageValidate: boolean = false;
	public selectedImage: string;
	public invoiceDataNotFound: boolean=false;
	public data;
	public dataNotFound: boolean = false;
	public user_id: string;
	public sortBy_Recurring = "created_at";
	public sort_Order = "DESC";
	

	constructor(private router: Router, private renderer: Renderer2, private elementRef: ElementRef, private location: Location, private  route: ActivatedRoute, private toastr: ToastrService, private userService :UserService, private echexpaymentService :EchexpaymentService, vcRef: ViewContainerRef, public modal: Modal, private localStorageService: LocalstorageService) { 
		this.mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
		this.router = router;
		var currentUser = this.localStorageService.getData("currentUserToken");
		this.token =  currentUser.data.user_token;
		let userDetails = this.localStorageService.getData("currentUser");
		this.id = userDetails._id;
	    
		this.user_id = userDetails._id;
	}

	fileToUpload: File = null;
	handleFileInput(files: FileList) {
	  if (files.length === 0) {
		return;
	  } 
	
	  const allowedFileTypes = [
		'image/jpeg',
		'image/png',
	  ];
	  const file = files[0];
	  if (!allowedFileTypes.includes(file.type)) {
		this.imageValidate = true;
		return;
	  } else{
		this.imageValidate = false;
	  }
	  this.fileToUpload = files.item(0);
	  const reader = new FileReader();
	  reader.onload = () => {
		this.selectedImage = reader.result as string;
	  };
	  reader.readAsDataURL(files[0]);
	}
  
	vendorlogoUpload: File = null;
	vendorlogo(files: FileList) {
	  if (files.length === 0) {
		return;
	  } 
	
	  const allowedFileTypes = [
		'image/jpeg',
		'image/png',
	  ];
	  const file = files[0];
	  if (!allowedFileTypes.includes(file.type)) {
		this.vendorimgValidate = true;
		return;
	  } else{
		this.vendorimgValidate = false;
	  }
	  this.vendorlogoUpload = files.item(0);
	  const reader = new FileReader();
	  reader.onload = () => {
		this.VendorImage = reader.result as string;
	  };
	  reader.readAsDataURL(files[0]);
	}

	ngOnInit() {
		this.getEchexMerchantDetailsForEdit();
		let params: any = this.route.snapshot.params;
		this.merchantId = params.merchant_id;
		this.getDocument_List();
	}
	
	
	
	// Get edit merchant data
	getEchexMerchantDetailsForEdit() {
		let params: any = this.route.snapshot.params;
		let data = {
		  token:this.id,
		  user_token:this.token,
		  id:params.id,
		}
		let responseData = <any>{};
		this.busy = this.echexpaymentService.getEchexMerchantEditPlanData(data).subscribe(
		   response => {
			  responseData = response;
			  this.echexMerchantProfile = responseData.data;
			  this.VendorImage = (responseData.data.business_image_url);
			  this.selectedImage = (responseData.data.image_url);
			  var whitelistedObj =    Helper.isEmpty(responseData.data.whitelisted_ips);
			  if(whitelistedObj === false){
				this.dataIpList = responseData.data.whitelisted_ips;
			  } 
			  var accountsObj =    Helper.isEmpty(responseData.data.accounts);
			  if(accountsObj === false){
			   this.echexMerchantBankDetails = responseData.data.accounts;
			  } 
			  var subscriptionsObj =    Helper.isEmpty(responseData.data.subscriptions);
			  if(subscriptionsObj === false){
				  this.echexMerchantPlan = responseData.data.subscriptions[0];
			  }
				if(responseData.data.settings){
				  if(responseData.data.settings){
					this.echexMerchantPlan.total_users =  responseData.data.settings.total_users;
					this.echexMerchantPlan.remaining_users = responseData.data.settings.remaining_users
				  }
				  if(responseData.data.settings){
					this.echexMerchantPlan.total_cheques = responseData.data.settings.total_cheques
					this.echexMerchantPlan.remaining_cheques =  responseData.data.settings.remaining_cheques;
				  }
			  }
		   },
		   error => {
			 responseData = error;
			 this.toastr.error(responseData.error.message, 'Failed!');
		   }
		);
	}

	moveNext(nextInput: HTMLInputElement, checkbox: number = 0) {
		
		if(checkbox === 1){
		} else if(checkbox === 2){
			if (this.submitButton && this.submitButton.nativeElement) {
				this.submitButton.nativeElement.focus();
				this.submitButton.nativeElement.click();
			}
		} else if(checkbox === 10){
			if (this.submit_Button && this.submit_Button.nativeElement) {
				this.submit_Button.nativeElement.focus();
				this.submit_Button.nativeElement.click();
			  }
		} else if(checkbox === 11){
			
			if (this.submit_button && this.submit_button.nativeElement) {
				this.submit_button.nativeElement.focus();
				this.submit_button.nativeElement.click();
			  }
		} else{
		  nextInput && nextInput.focus();
		}
	  }

	  ngAfterViewInit(){
		setTimeout(() => {
		  const businessNameElement = document.querySelector('#Business_name') as HTMLInputElement;
		  if (businessNameElement) {
			this.renderer.selectRootElement(businessNameElement).focus();
		  }
		}, 0);       
	  }
	// Update merchant profile
	updateMerchantProfile(data){
		this.focusFirstInvalidControlPlus();   //focus field
		if(data.valid){
			let model: any = data.value;
			let params: any = this.route.snapshot.params;
			model.id = params.id;
			model.token = this.id;
			model.user_token = this.token;

			const formData = new FormData();
			if (this.fileToUpload) {
			  formData.append('photo', this.fileToUpload, this.fileToUpload.name);
			 
			}
			// Image validation
			if (this.imageValidate === true) {
			  return;
			}
			if (this.vendorimgValidate === true) {
			  return;
			}
			if(this.vendorlogoUpload){
			  formData.append('vendor_logo', this.vendorlogoUpload, this.vendorlogoUpload.name);
			}   
		
			Object.entries(model).forEach(([key, value]) => {
			  formData.append(key, value as any);
			});


			let responseData = <any>{};
			this.busy = this.echexpaymentService.updateMerchantProfile(model, formData).subscribe(
			response => {
				responseData = response;
				this.toastr.success(responseData.message, 'Success!');
			},
			error => {
			responseData = error;
			this.toastr.error(responseData.error.message, 'Failed!');
			}
			);
		}
	}

	// Generate api details for merchant
	genrate(model){
		if (this.echexMerchantProfile.api_key && this.echexMerchantProfile.api_secret) {
			this.echexMerchantProfile.api_key = '';
			this.echexMerchantProfile.api_secret = '';
		} else {
				let params: any = this.route.snapshot.params;
				model.id = params.id;
				model.token = params.id;
				model.user_token = this.token;
				let responseData = <any>{};
				this.busy = this.echexpaymentService.updateMerchantApi(model).subscribe(
				response => {
					responseData = response;
					this.echexMerchantProfile.api_key = responseData.data.api.api_key;
					this.echexMerchantProfile.api_secret = responseData.data.api.api_secret;
					this.toastr.success(responseData.message, 'Success!');
				},
				error => {
					responseData = error;
					this.toastr.error(responseData.error.message, 'Failed!');
				}
				);
		}
	}


	// Focus Error field
	focusFirstInvalidControlPlus(): void {
		const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
		if (firstElementWithErrors) {
			firstElementWithErrors.focus();
		}
	}

	// Whitelist merchant ip
	whitelist(data){
		this.focusFirstInvalidControlPlus();   //focus field
		if(data.valid){
			let model: any = data.value;
			let params: any = this.route.snapshot.params;
			model.id = params.id;
			model.token = params.id;
			model.user_token = this.token;
			let responseData = <any>{};
			this.busy = this.echexpaymentService.whitelistMerchantIp(model).subscribe(
			response => {
			responseData = response;
			if(responseData.data.whitelisted_ips){
				this.dataIpList = responseData.data.whitelisted_ips;
			}
			this.toastr.success(responseData.message, 'Success!');
			},
			error => {
			responseData = error;
			this.toastr.error(responseData.error.message, 'Failed!');
			}
			);
		}
	}
	// Delete Ip
	deleteIp(event,ip){
	    let responseData = <any>{};
		event.stopPropagation();
		this.modal.confirm()
		  .size('sm')
		  .title('CasherPay')
		  .body(`Are you sure to delete this IP.`)
		  .okBtn('Okay')
		  .cancelBtn('Cancel')
		  .okBtnClass('btn btn-success')
		  .cancelBtnClass('btn btn-warning')
		.open()
		.then( (resultPromise) => {
			resultPromise.result.then( (result) => {
			let params: any = this.route.snapshot.params;
			 var data = {
				user_token:this.token,
				token:params.id,
				id:params.id,
				ip:ip
			  }

			this.busy = this.echexpaymentService.deleteMerchantIp(data).subscribe(
				 response => {
				    responseData = response;
					if(responseData.data.whitelisted_ips.length > 0){
					this.dataIpList = responseData.data.whitelisted_ips;
					}
					this.toastr.success(responseData.message, 'Success!');
				 },
				 error => {
				  responseData = error;
				  this.toastr.error(responseData.error.message, 'Failed!');
				 }
			);
		  }, 
		  () => {
		   console.log('Cancel');
		  } );
		});
	}
	// event handler for validation
	eventHandler(){
		this.val_plan_name = false;
		this.val_plan_id = false;
		this.val_no_of_cheque = false;
		this.val_no_of_user = false;
		this.val_amount = false;
		this.val_status = false;
		this.val_interval = false;
		this.val_trial_period = false;
		this.val_settings = false;
		this.val_appear_in = false;
	}

	goBack() {
		this.location.back();
	}

	// Update Merchant Plan
	updateMerchantPlan(data){ 
		this.focusFirstInvalidControlPlus();   //focus field
		if(data.valid){
		    let model: any = data.value;
			let params: any = this.route.snapshot.params;
			model.id = params.id;
			model.token = params.id;
			model.user_token = this.token;
			model.updatePlanSettings = true;
			let responseData = <any>{};
			this.busy = this.echexpaymentService.updateMerchantPlanAPi(model).subscribe(
				response => {
				responseData = response;
				this.toastr.success(responseData.message, 'Success!');
				this.getEchexMerchantDetailsForEdit();
				},
				error => {
				responseData = error;
				this.toastr.error(responseData.error.message, 'Failed!');
				}
			);
		}
	}

	// Document List 
	getDocument_List() {
		let data = {
		  user_token:this.token,
		  merchantId:this.merchantId,
		}
		let responseData = <any>{};
		this.busy = this.userService.GetDocumentList(data).subscribe(
		   	response => {
			  responseData = response;
				this.getDoc_List = responseData.data;
				if(responseData.data.length == 0){
					this.doc_dataNotFound =  responseData.message
				}
		   	},
		   	error => {
			    responseData = error;
		   	}
		);
	}

  	EditDocumentId(files: FileList, editId: string){
		if (files.length === 0) {
			return;
		}
  
    	const allowedFileTypes = [
			'image/jpeg',
			'image/png',
			'text/csv', // CSV
			'image/webp',
			'application/msword', // DOC
			'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // DOCX
			'application/pdf',
			'application/vnd.ms-excel',
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // Excel (XLSX)
    	];

    	const file = files[0];
    	if (!allowedFileTypes.includes(file.type)) {
      		this.chequeerror_res = 'Only files with the following extensions are allowed: jpg, png, csv, jpeg, webp, doc, docx, pdf, excel';
      		setTimeout(() => {
        		this.chequeerror_res = '';
      		}, 8000); // Hide error message after 5 seconds
	      	return;
    	}
    
    	let data = {
      		"merchantId": this.merchantId,
      		"user_token": this.token,
    	};
  
    	let filedata = {
      		"id": editId
    	};
  
    	const formData = new FormData();
    	formData.append('document', file, file.name);
  
    	Object.entries(filedata).forEach(([key, value]) => {
      		formData.append(key, value as any);
    	});
  
    	let uploadlastmonthData = <any>{};
    	this.busy = this.userService.EditDocument_id(data, formData).subscribe(
			response => {
				uploadlastmonthData = response;
				this.getDocument_List();
				this.toastr.success(uploadlastmonthData.message, 'Success!');	
			},
			error => {
				uploadlastmonthData = error;
				this.toastr.error(error.message, 'Failed!');
			}
		);
  	}

	// force download file
    downloadFile(url, name){
		fetch(url)
		.then(resp => resp.blob())
		.then(blob => {
			const url = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.style.display = 'none';
			a.href = url;
			// the filename you want
			a.download = name;
			document.body.appendChild(a);
			a.click();
			window.URL.revokeObjectURL(url);
		})
		.catch(() => alert('An error sorry'));
	}


	NameCharacterLimit(event: any, fieldName: string) {
		const maxTextLength = 25; // Maximum text length of 20 characters
		const inputChar = event.key;
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	  
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
		  return;
		}
	  
		const inputValue = event.target.value;
	  
		if (inputValue.length >= maxTextLength) {
		  if (allowedKeys.indexOf(inputChar) === -1) {
			this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
			setTimeout(() => {
			  this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
			}, 3000);
			event.preventDefault(); // Prevent entering the exceeded character
		  }
		}
	  }
	  
	  isNameLimitReached(fieldName: string): boolean {
		return this.NamecharacterLimitReached[fieldName];
	  }


	        // + country code in phone field
  validateInput(event: any): void {
    const inputValue = event.target.value;
    const firstChar = inputValue.charAt(0);
    const keyCode = event.keyCode || event.which;
  
    // Allow only numeric digits (0-9) and backspace/delete keys
    if (keyCode < 48 || keyCode > 57) {
      event.preventDefault();
    }
    
    // Limit the input length to 4 characters
    if (inputValue.length >= 4 && keyCode !== 8 && keyCode !== 46) {
      event.preventDefault();
    }
    
    // Make the first character read-only "+"
    if (inputValue.length === 0) {
      event.target.value = "+";
    }
  }
  
  handleInputChange(event: any): void {
    const inputValue = event.target.value;
    const firstChar = inputValue.charAt(0);
  
    // If the input value is empty or contains non-numeric characters, reset the input value with "+"
    if (!inputValue || !(/^\+\d*$/.test(inputValue))) {
      event.target.value = "+";
    }
  }
  // End + country code in phone field


  handleTabClick(tabTitle: string) {
	if (tabTitle === 'Plan') {
		setTimeout(() => {
		 const businessNameElement = document.querySelector('#FocusNoOfcheck') as HTMLInputElement;
		 if (businessNameElement) {
		 this.renderer.selectRootElement(businessNameElement).focus();
		 }
	 }, 0); 
	}
	if (tabTitle === 'API') {
	   setTimeout(() => {
			const businessNameElement = document.querySelector('#ip') as HTMLInputElement;
			if (businessNameElement) {
			this.renderer.selectRootElement(businessNameElement).focus();
			}
	    }, 0); 
		this.getEchexMerchantDetailsForEdit()
	}
	if (tabTitle === 'Profile') {
		setTimeout(() => {
			const businessNameElement = document.querySelector('#Business_name') as HTMLInputElement;
			if (businessNameElement) {
			this.renderer.selectRootElement(businessNameElement).focus();
			}
		}, 0); 
	}
	
	if(tabTitle === 'Document Details'){
		this.getDocument_List();
	}

	if (tabTitle === 'Invoice Recurring') {
		this.getInvoice_List();
	}

	if(tabTitle === 'Recurring'){
		this.getAllTransaction();
	}

 }


 getInvoice_List() {
	let data = {
	  user_token:this.token,
	  merchantId:this.merchantId,
	}
	let responseData = <any>{};
	this.busy = this.userService.GetRecurringInvoiceList(data).subscribe(
	   response => {
		  responseData = response;
	  this.data = responseData.data;
	  if(responseData.data.length == 0){
		this.invoiceDataNotFound =  responseData.message;
	  } else {
		this.invoiceDataNotFound = false;
	  } 
	   },
	   error => {
			responseData = error;
	   }
	);
}

    //Recurring
    getAllTransaction()
    {
	let params: any = this.route.snapshot.params;
      var data = {
            user_token: this.token,
            token: params.id,
            _id: params.id,
            recurrent : 1
      }
       
       let responseData = <any>{};
         this.busy = this.echexpaymentService.getAllTransactionData(data).subscribe(
           response => {
                responseData = response;
                var checkAmount;
                checkAmount = 0;
                this.data = responseData.data;
                if(this.data.length == 0){
                  this.dataNotFound =  responseData.message
                }
                this.data.forEach(function (eachObj) {
                  checkAmount = parseFloat(checkAmount) + parseFloat(eachObj.cheque_amount);
                });
           },
           error => {
              responseData = error;
              this.toastr.error(responseData.error.message, 'Failed!');
           }
        );
    }

	removeRecurring(id:any){
		event.stopPropagation();
		this.modal.confirm()
			.size('sm')
			.title('CasherPay')
			.body(`Are you sure to delete this Recurring.` )
			.okBtn('Yes')
			.cancelBtn('Cancel')
			.okBtnClass('btn btn-success')
			.cancelBtnClass('btn btn-warning')
			.open()
			.then( (resultPromise) => {
			  	resultPromise.result.then( (result) => {
				  var data = {
					  token: this.user_id,
					  user_token: this.token,
					  _id : id,
					  merchant_id: this.user_id,
				  }
				  let responseData = <any>{};
					this.busy = this.echexpaymentService.DeleteRecurring(data).subscribe(
					  response => {
							responseData = response;
							this.toastr.success(responseData.message, 'Success!');
							this.getAllTransaction();
					  },
					  error => {
						  responseData = error;
						  this.toastr.error(responseData.error.message, 'Failed!');
					  }
					);
				},
				() => {
					console.log('Cancel');
				} );
			});
	}

	removeInvoiceRecurring(id:any){
		event.stopPropagation();
		this.modal.confirm()
		  .size('sm')
		  .title('CasherPay')
		  .body(`Are you sure to delete this Invoice Recurring.` )
		  .okBtn('Yes')
		  .cancelBtn('Cancel')
		  .okBtnClass('btn btn-success')
		  .cancelBtnClass('btn btn-warning')
		  .open()
		  .then( (resultPromise) => {
			  resultPromise.result.then( (result) => {
				  var data = {
					  token: this.user_id,
					  user_token: this.token,
					  _id : id,
					  merchant_id: this.user_id,
				  }
				  let responseData = <any>{};
					this.busy = this.echexpaymentService.DeleteInvoiceRecurring(data).subscribe(
					  response => {
							responseData = response;
							this.toastr.success(responseData.message, 'Success!');
							this.getInvoice_List();
					  },
					  error => {
						  responseData = error;
						  this.toastr.error(responseData.error.message, 'Failed!');
					  }
					);
			  },
			  () => {
				console.log('Cancel');
			  } );
		  });
	  }


	  validateNumberInput(event: any) {
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	  
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
		  // Allow the default behavior for certain keys
		  return;
		}
	  
		if (!/^\d+$/.test(event.key)) {
		  // Prevent input if it's not a digit
		  event.preventDefault();
		}
	  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/echexmerchant/editechexmerchant.component.ts